
import { Rol } from "./rol";
import { enumObject, mapObject } from "keautils";

type DeclaracionRecursiva<T> = { [K in keyof T]: DeclaracionRecursiva<T[K]> | string | undefined }

export type RolTreeType = DeclaracionRecursiva<Rol>;
const InfoCatalogo = {
    Agregar: "Agregar un nuevo elemento",
    Borrar: "Borrar un elemento",
    Consultar: "Consultar los elementos del catálogo",
    Editar: "Editar un elemento existente",
    VerMenu: "Ver el link de acceso"
};

//Al agregar un nuevo rol agregalo a este objeto para que aparezca en la UI:

/**
 * Esta variable se usara para alimentar al componente de edicion de los roles, el cual va a mostrar todos los roles que tengan una 
 * descripción diferente de undefined
 */
export const DeclaracionRoles: RolTreeType = {
    Nombre: undefined,
    EsSiteAdmin: undefined,
    IdRegistro: undefined,
    BotonSugerencias_VerEncabezado_2:undefined,

    EntregaOcurre: {
        RealizarEntrega: "Realizar la entrega a ocurre",
        VerMenu: "Ver el link de acceso",
        VerCabecera: "Ver el link en la cabecera",
        ImprimirAcusesInternos: "Permiso para imprimir los acuses internos de un viaje",
        ConsultarEntrega: "Permiso para consultar la entrega",
        ConsultarEntregasSucursalDiferenteUsuario: "Consultar las entregas a domicilio realizadas en sucursales diferentes a la asignada al usuario",
        MostrarGuiasSucursalDiferenteUsuario: "Consultar las entregas a domicilio realizadas en sucursales diferentes a la asignada al usuario",
    },
    Catalogos: {
        VerCabecera: "Ver el link en la cabecera",
        ChoferEAD: {
            ...InfoCatalogo,
            ConsultarChoferCualquierSucursal: "Si se deshabilita el usuario sólo podrá consultar choferes asignados a la misma sucursal que el usuario",
        },
        ChoferZE: {
            ...InfoCatalogo,
            ConsultarChoferCualquierSucursal: "Si se deshabilita el usuario sólo podrá consultar choferes asignados a la misma sucursal que el usuario",
        },
        RutaEAD: {
            ...InfoCatalogo,
            ConsultarRutasCualquierSucursal: "Si se deshabilita el usuario sólo podrá consultar rutas asignados a la misma sucursal que el usuario",
        },
        CamionEAD: {
            ...InfoCatalogo,
            ConsultarCamionesCualquierSucursal: "Si se deshabilita el usuario sólo podrá consultar camiones asignados a la misma sucursal que el usuario"
        },
        PartidaAclaracion: {
            ...InfoCatalogo,
        },
        Tarifa: InfoCatalogo,
        MatrizTiempo: InfoCatalogo,
        Banco: InfoCatalogo,
        Caja: {
            ...InfoCatalogo,
            ConsultarCajasSucursalDiferenteUsuario: "True para que el usuario puede consultar cajas incluso de sucursales diferentes a la que el usuario tiene asignado, false para que el usuario pueda consultar cajas solamente de su sucursal"
        },
        Cliente: {
            ...InfoCatalogo,
            ModificarNombre: "True para que el usuario pueda modificar el nombre cliente",
            ModificarRFC: "True para que el usuario pueda modificar el RFC cliente",
            ModificarDireccionFiscal: "True para que el usuario pueda modificar el Dirección fiscal cliente",
            ModificarFechaInicioComision: "True para que el usuario pueda modificar el Fecha inicio de comisiones cliente",
            ModificarVendedor: "True para que el usuario pueda modificar el vendedor cliente",
            ModificarTarifa: "True para que el usuario pueda modificar el tarifa cliente",
            ModificarDireccionCredito: "True para que el usuario pueda modificar la dirección de credito del cliente",
            ConsultarTodosClientes: "Permite a este usuario consultar todos los clientes",
            EditarDesdeListadoGuias: "Permite editar un cliente desde el listado de guias",
            EditarSeccion: {
                General: "",
                Comercial: "",
                Identificacion: "",
                Direcciones: "",
                CreditoCobranza: "",
                Facturacion: "",
                ClientesRelacionados: "",
                Paquetes: ""
            }
        },
        Rol: InfoCatalogo,
        Usuario: {
            ...InfoCatalogo,
            ConsultarIdSucursalDeUsuario: "Permite al usuario realizar la consulta del IdSucursal de un usuario. Note que este permiso es necesario para la creación de turnos."
        },
        Articulo: InfoCatalogo,
        CajaRuta: InfoCatalogo,
        ChoferRuta: InfoCatalogo,
        ContenidoPaquete: InfoCatalogo,
        ContenidoSobre: InfoCatalogo,
        DescripcionPaquete: {
            ...InfoCatalogo,
            ConsultarTodasDescripcionesPaquetes: "True para mostrar todas las descripciones de paquetes en los selectores de descripción de paquetes"
        },
        MatrizTarifa: {
            ...InfoCatalogo,
            DuplicarMatriz: "Si es true permite duplicar una matriz de tarifas"
        },
        MatrizDistancia: InfoCatalogo,
        Sucursal: {
            ...InfoCatalogo,
            ConsultarInformacionSAT: "Permite consultar la información fiscal que se guarda en esta sucursal",
            ModificarInformacionSAT: "Permite modificar la información fiscal que se guarda en esta sucursal",
            ConsultarInformacionTasas: "Permite consultar la información de las tasas de impuestos de la sucursal",
            ModificarInformacionTasas: "Permite modificar la información de las tasas de impuestos de la sucursal"
        },
        RequerimientoAcuse: InfoCatalogo,
        Segmento: InfoCatalogo,
        Camion: InfoCatalogo,
        Ruta: InfoCatalogo,
        Vendedor: InfoCatalogo,
        Cobradores: InfoCatalogo,
        TarifaPagoChoferes: InfoCatalogo,
        ZonaExtendida: InfoCatalogo,
        UsuarioZE: InfoCatalogo,
        TarifaPP: InfoCatalogo,
        UsuarioApi: InfoCatalogo
    },
    DepositosBanco: {
        VerMenu: "True para que el usuario pueda ver el link en el menú de operativa",
        Consultar: "True para que el usuario pueda consultar los datos de los deposito de banco.",
        ContabilizarDepositoBanco: "Permite contabilizar un deposito de banco"
    },
    Documentacion: {
        Consultar: "Consultar el listado de las documentaciones, si este permiso esta deshabilitado no podra consultar ninguna documentación",
        ConsultarTodasDocumentaciones: "Si se habilita, no se tendrá ningun filtro para las documentaciones que puede ver el usuario. Este permiso toma precedencia sobre el permiso 'ConsultarDocumentacionesClienteUsuario'",
        ConsultarDocumentacionesClienteUsuario: "Si se habilita, el usuario podrá ver todas las documentaciones con el cliente origen igual al cliente relacionado con el usuario",
        Documentar: "Crear una nueva documentación",
        ImprimirGuias: "Imprimir el reporte de guias y etiquetas",
        VerMenu: "Ver el link en el menu",
        VerMenuDocumentaciones: "Ver el link de documentaciones",
        DocumentarCualquierClienteOrigen: "Habilitar par poder seleccionar cualquier cliente origen en la documentación, si no, solamente se podrá seleccionar el cliente asignado al usuario. ",
        FletePorCobrar: "Permitir realizar documentaciones de guias con flete por cobrar en la documentación",
        PagoContado: "Permitir a este usuario realizar pagos de contado en la documentación de las guias",
        PagoCredito: "Permitir realizar pagos a crédito en la documentación de las guias",
        VerCabecera: "Ver el link en la cabecera",
        DocumentacionEnSucursal: "Permiso para marcar las guias como documentadas en sucursal, en caso de no tenerlo se van a marcar las guias como documentadas en linea, este permiso debe de estar habilitado para los documentadores de la empresa y deshabilitado para los roles diseñados para los clientes finales",
        DocumentarGuiaSinRecoleccionDomicilio: "Permite al usuario documentar guias que no tengan el servicio adicional de recolección a domicilio, este permiso debe de esta deshabilitado para los roles de documentación en linea ya que los clientes finales no pueden documentar una guia que ya se encuentre en sucursal",
        ObtenerGuias: "Permiso para consultar las guias que van a ser creadas a partir de una documentación",
        DocumentarCualquierSucursalOrigen: "Habilitar para poder seleccionar cualquier sucursal de origen en la documentación, si no, solamente se podrán documentar guias con la sucursal de origen igual a la del usuario actual",
        DocumentarCualquierOrigen: "Le permite al usuario seleccionar cualquier dirección de origen",
        VerModificarCheckBoxRecoleccionDomicilioEnDocumentacion: "Permite al usuario modificar el check box del servicio adicional 'Recoleccion a domicilio' en la documentación de guía",
        VerPagoContado: "Permitir a este usuario ver la interfaz de pagos de contado en la documentación de las guias",
        VerPagoCredito: "Permitira este usuario ver la interfaz de pagos a crédito en la documentación de las guias",
        AsignarSeguroDefault: "Indica si se le asignará por default el valor del seguro del paquete"
    },
    EntregaDomicilio: {
        CancelarCargaDescarga: "Cancelar una carga/descarga",
        CancelarViaje: "Cancelar un viaje",
        ConsultarCargaDescarga: "Consulta el listado de cargas/descargas",
        ConsultarViajes: "Consultar el listado de los viajes",
        CrearViaje: "Crear un nuevo viaje",
        DarLlegadaViaje: "Dar llegada a un viaje",
        EscanearFolioCargaDescarga: "Escanear un servicio para una carga/descarga en proceso",
        FinalizarCargaDescarga: "Finalizar el proceso de carga/descarga",
        IniciarCargaDescarga: "Iniciar el proceso de carga/descarga",
        QuitarServicioCargaDescarga: "Quitar un servicio de una carga/descarga en proceso",
        VerMenuCargaDescarga: "Ver el link para las cargas/descargas",
        VerMenuViajes: "Ver el link para los viajes",
        DarSalidaViaje: "El usuario le puede dar salida a un viaje",
        FinalizarViajeApp: "Permiso para finalizar el viaje de la app móvil",
        IniciarViajeApp: "Permiso para iniciar el viaje en la app móvil",
        ObtenerDatosViajeApp: "El usuario puede obtener los datos de viaje para su uso en la app móvil sin conexión. Este permiso es necesario si se quiere realizar un viaje de EAD",
        SincronizarDatosViajeApp: "Permiso para realizar la sincronización de datos entre el cliente y el servidor de los datos de la app móvil. Este permiso aplica tanto para la sincronización de subida como para la de bajada",
        VerLinkViajeAppActual: "Ver el link para entrar al viaje actual en la app móvil",
        ObtenerViajesPosiblesInicioApp: "Permiso para obtener el listado de viajes posibles de inicio en la app",
        PuedeIniciarViajeCualquierSucursal: "Si el usuario puede iniciar un viaje de EAD en la app de cualquier sucursal, si no, solo podra iniciar un viaje de la sucursal asignada al usuario",
        PuedeMarcarFinalizadoPendienteDescarga: "Si el usuario puede marcar un viaje de EAD como finalizado pero pendiente de descarga , esto es lo mismo que darle llegada al viaje desde la parte web",
        PuedeMarcarPendienteVerificacion: "Si el usuario puede marcar un viaje de EAD como pendiente de verificación",
        PuedeFinalizarViaje: "Si el usuario puede finalizar un viaje, esto es, realizar la verificación final de las guias y acuses firmados de un viaje",
        VerViajeAppCabecera: "Ver el link de 'Viaje App' en la cabecera",
        VerViajesCabecera: "Ver el link de 'Viajes de EAD' en la cabecera",
        CancelarViajeAppDesdeWeb: "Permite cancelar un viaje de entrega a domicilio iniciado en la app desde la parte web",
        ConsultarViajesSucuersalDiferenteUsuario: "Si se deshabilita el usuario sólo podrá ver los viajes de su misma sucursal",
        ConsultarCargaDescargaSucursalDiferenteUsuario: "El usuario puede ver cargas/descargas incluso cuando estas son de una sucursal diferente a la asignada al usuario",
        TeclearFolioEnCargaDescarga: "True para poder teclear el folio en una carga / descarga, falso sólo para permitir escanear con el celular "
    },
    ZonaExtendida: {
        IniciarCualquierSucursal: "Permite iniciar un viaje app de un viaje de ze sin importar la sucursal del usuario",
        ObtenerIdViajeZeUsuario: "Permite obtener el id del viaje de ze del usuario actual",
        ObtenerDatosViajeZEApp: "Permite obtener los datos del viaje app de ZE",
        IniciarViajeZEApp: "Permite iniciar un viaje app de ZE",
        FinalizarViajeZEApp: "Permite finalizar un viaje app de ZE",
        CancelarViajeZEApp: "Permite cancelar un viaje app de ZE",
        CrearViajeZE: "Permite crear un nuevo viaje de ZE",
        ConsultarViajesZE: "Permite consultar viajes de ZE",
        DarSalidaViajeZE: "Permite dar salida a viajes de ZE",
        CancelarViajeZE: "Permite cancelar viajes de ZE",
        FinalizarViajeZE: "Permite finalizar viajes de ZE",
        ObtenerInicios: "Permite obtener los posibles viajes app de ZE que puede iniciar el usuario",
        ConsultarEntregaZE: "Permite consultar las entregas de Zona extendida",
        RealizarEntregaZE: "Permite realizar entregas de zona extendida ",
        ObtenerGuiasEnEntregaZE: "Permite obtener las guías que pertenecen a una entrega de zona extendida ",
        VerMenuViajeZEApp: "Permite ver el link de viaje zona extendida app",
        VerMenuViajeZE: "Permite ver el link de viaje zona extendida",
        VerMenuEntregasRealizadasZE: "Permite ver el link de las Entregas realizadas de zona extendida",
        PuedeMarcarPendienteVerificacion: "Permite marcar un viaje como pendiente de verificación",
        VerBotonDarIniciarViajeZE: "Muestra el botón de dar inicio a viaje ZE",
        VerBotonCancelarViajeZE: "Muestra el botón de cancelar viaje ZE",
        VerMenuConsultaEntregasSucursalZE: "Muestra el menú a la sección de las guías que hay que entregar en una sucursal de forma de ZE",
        ConsultarGuiasEntregarSucursalZE: "Permite consultar las guías a entregar en una sucursal de zona extendida",
        VerSelectorSucursalZonaExtendida: "Permite ver el selector de sucursal de zona extendida",
        PonerValorDeSucursalFijoEnSelector:"si esta activo pone fija la sucursal ligada al cliente",
        ConsultarGuiasTodasSucursales: "Si esta activo podra ver todas las guias ZE, si no esta activo solo podra ver las de su sucursal"
    },
    VerNavBar: "Ver la barra superior con los menús",
    VerBotonDescargarApp: "Ver botón para descargar la app en la pantalla de inicio",
    BotonSugerencias_VerEncabezado: "Ver botón para enviar sugerencia",
    Seguridad: {
        EditarUsuariosYRoles: "Acceso total al catálogo de usuarios y de roles de seguridad",
        ImpersonalUsuario: "Permiso para acceder con cualquier usuario sin conocer su contraseña",
        VerBitacora: "Ver la bitácora de eventos",
    },
    Configuraciones: {
        ObtenerConfiguraciones: "Ver todas las configuraciones",
        EditarConfiguraciones: "Modificar todas las configuraciones",
        DescargarAPK: "Permiso para descargar el APK desde el botón",
        PuedeModificarAvisoPrivacidad: "Puede modificar aviso de privacidadad"
    },
    Facturas: {
        ContabilizarManualmenteFactura: "Si se deshabilita el usuario no podrá contabilizar facturas manualmente",
        VerMenu: "Ver el link de facturas",
        VerCrearFacturaArbitraria: "Permite ver los componentes para la creación de facturas arbitrarias",
        CrearFacturaArbitraria: "Permite crear una factura de forma manual",
        VerBotonTimbrarFactura: "Permite ver el botón para timbrar las facturas en el front end",
        TimbrarFactura: "Permite timbrar alguna factura",
        VerBotonCancelarFactura: "Permite ver el botón de cancelar factura en el front-end",
        CancelarFactura: "Permite cancelar alguna factura",
        VerGenerarNotaDeCargo: "Permite ver los componentes para crear una nota de credito en el front-end",
        GenerarNotaDeCredito: "Permite generar una nota de crédito a partir de un factura ya timbrada",
        VerGenerarNotaDeCredito: "Permite ver los componentes para generar una nota de cargo en el front-end",
        GenerarNotaDeCargo: "Permite generar una nota de cargo a partir de una factura previamente timbrada",
        VerFacturarGuias: "Permite el acceso a la pantalla de facturación de guías",
        FacturarGuias: "Permite al usuario facturar guías directamente seleccionandolas",
        FacturarGuiasPP: "Permiso para facturar guías de PP",
        FacturarGuiasSinTimbrar: "Permite al usuario facturar guías pero sin timbrarlas directamente seleccionandolas",
        VerFacturarGuiasPublicoGeneral: "Permite el acceso a la pantalla de facturación de guías de público general",
        FacturarGuiasPublicoGeneral: "Permite facturar todas las guías que se encuentren disponibles para la facturación",
        FacturarGuiasPublicoGeneralSinTimbrar: "Permite facturar sin timbrar todas las guias que se encuentren disponibles en la facturación",
        VerBotonFacturarGuiaPublicoGenerarSinTimbrar: "Permite ver el botón para facturar guias de publico general sin timbrar",
        VerBotonFacturarGuiaPublicoGenerarTimbrar: "Permite ver el botón para facturar guias de publico general",
        VerBotonEliminarFactura: "Permite ver el botón de eliminar factura en el front-end ",
        EliminarFactura: "Permite eliminar una factura",
        ConsultarFacturas: "Si se deshabilita el usuario no podrá ver ninguna factura",
        ConsultarFacturasSucursalDiferenteUsuario: "Si se deshabilita el usuario sólo podra ver facturas de su misma sucursal",
        EditarFactura: "Permiso para editar manualmente una factura",
        DescargarFactura: "Si se deshabilita el usuario no podra descargar ni el XML ni el PDF de una factura",
        DuplicarFactura: "Permite duplicar una factura. Este permiso es muy delicado ya que la duplicación de la factura también trae consigo las relaciones de la facturación de guias",
        GenerarPolizaDeCancelacion: "Permite generar una poliza de cancelación a partir de una factura donde su timbre esté cancelado",
        VerBotonGenerarPolizaDeCancelacion: "Muestra el botón de generar poliza de cancelación en el front-end",
        TimbrarContrareciboNoCobrado: "Permite timbrar una factura anexa a un contrarecibo que no ha sido pagado",
        DescargarFacturaSinTimbrar: "Permite al usuario descargar un documento que represente a la factura antes de ser timbrada",
        CorregirFacturaCobranza: "Permite corregir una factura de cobranza que haya sido pagada",
        VerBotonCorregirFacturaCobranza: "Muestra el botón para corregir una factura",
        EnviarCorreoFactura: "Permité mandar un email con el contenido de la factura",
        VerBotonEnviarCorreoFactura: "Muestra el botón para envíar correos de facturación",
        VerReps: "Ver listado de REP",
        ConsultarRep: "Consultar REP",
        GenerarRep: "Generar REP",
        VerbotonGenerarRep: "Mostrar botón para generar un REP",
        TimbrarREP: "Timbrar un REP",
        VerBotonTimbrarREP: "Ver boton para Timbrar REP",
        CancelarREP: "Cancelar un REP",
        VerBotonCancelarREP: "Ver botón para cancelar un REP",
        EliminarREP: "Eliminar un rep",
        VerBotonEliminarREP: "Ver botón de eliminar REP",
        DescargarREP: "Descargar archivos de REP",
        VerBotonDescargarREP: "Ver botón de descargar archivos de REP",
        ObtenerReporteDetalleFacturaCobranza: "Permite obtener el reporte de detalle de factura cobranza",
        VerBotonCancelarMultiFacturas: "Ver botón para cancelar multiples facturas"
    },
    VentaDiaria: {
        VerMenu: "Ver el link de reporte diario de ventas",
        GenerarReporteVentaDiaria: "Permite generar el reporte de venta diaria"
    },
    Reportes:
    {
        VerMenu: "Ver el link de reportes",
        VerReporteCobranzaSemanal: "Ver el link del reporte de cobranza semanal",
        GenerarReporteCobranzaSemanal: "Permite generar el reporte de cobranza semanal",
        VerReporteGuiasEnviadasYRecibidas: "Ver el link del reporte de guías enviadas y recibidas",
        GenerarReporteGuiasEnviadasYRecibidas: "Permite generar el reporte de guías enviadas y recibidas",
        VerReporteSeguimientoDeVentas: "Ver el link del reporte de seguimiento de ventas",
        GenerarReporteSeguimientoDeVentas: "Permite generar el reporte de seguimiento de ventas",
        VerReporteEstadisticasClientes: "Ver el link del reporte de estadísticas de clientes",
        GenerarReporteEstadisticasClientes: "Permite generar el reporte de estadísticas de clientes",
        VerReporteEnviosPorCanalDeComercializacion: "Ver el link del reporte de envíos por canal de comercialización",
        GenerarReporteEnviosPorCanalDeComercializacion: "Permite generar el reporte de envíos por canal de comercialización",
        VerReporteEficienciaEAD: "Ver el link del reporte de eficiencia EAD",
        GenerarReporteEficienciaEAD: "Permite generar el reporte de eficiencia EAD",
        GenerarReporteVentaPP: "Generar el reporte de venta de PP",
        VerReporteVentaPP: "Ver el link del reporte de venta de PP",
        VerTodasSucursalesReporteVentaPP: "Ver todas las sucursales en el reporte de ventas pp y seleccionar una sucursal diferente a la asignada ",
        GenerarReportePaquetesPP: "Generar el reporte de venta de PP",
        VerReportePaquetesPP: "Ver el link del reporte de venta de PP",
        VerMenuReporteConteoGuias: "Ver en el menú reporte de conteo de guías",
        GenerarReporteConteoGuias: "Generar el reporte de conteo de guías",
        GenerarReporteGuiasDoc: "Generar el reporte de guias documentadas / inventarios",
        VerReporteGuiasDoc: "Ver el link del reporte de guias documentadas / inventarios",
        GenerarReportePartidasAclaracion: "Generar el reporte de partidas en aclaración",
        VerReportePartidasAclaracion: "Ver el link del reporte de partidas en aclaración",
        GenerarReporteConsultaGuias: "Generar el reporte de consulta de guías",
        VerReporteConsultaGuias: "Ver el link del reporte consulta de guías",
        VerReporteCargaAdministradores: "Permiso de la vista para permitirle al usuario ver el botón con el que se genera el reporte de carga de administradores",
        GenerarReporteCargaAdministradores: "Permiso para que el usuario pueda generar el reporte de carga de administradores",
        VerReporteSaldoCartera: "Ver el reporte de saldos de cartera / Notas de crédito",
        GenerarReporteSaldoCartera: "Generar el Reporte de saldos de cartera / Notas de crédito",
        VerReporteLibroAdministracion: "Ver el Reporte libro administración de sucursales",
        GenerarReporteLibroAdministracion: "Generar el Reporte libro administración de sucursales",
        VerMenuAntiguedadSaldos: "Ver el link del reporte de antigüedad de saldos",
        VerMenuEstadoCuenta: "Ver el link del reporte de estado de cuenta",
        VerMenuReporteComportamientoComercial: "Ver el link del reporte de comportamiento comercial",
        VerTodosClientesReportes: "Si es true los selectores de clientes en los reportes muestran a todos los clientes, si no, muestran sólo al cliente relacionado del usuario",
        ReportePaquetesPPVistaVendedores:"solo puede ver los paquetes de guías PP que fueron emitidas de su sucursal y no podrá ver los números de guías que no se han usado"
    },
    Turnos: {
        VerMenu: "Ver link de turnos",
        MostrarTurnos: "Permite obtener el listado de turnos",
        VerIniciarTurno: "Muestra el botón para inicar un nuevo turno",
        IniciarTurno: "Permite iniciar un turno para el usuario actual",
        VerSelectorUsuarioNuevoTurno: "Muestra el selectro de usuarios al capturar un nuevo turno",
        VerFinalizarTurno: "Muestra el botón para finalizar un turno",
        FinalizarTurno: "Permite finalizar un turno",
        VerCorteTurno: "Permite ver la información del corte de turno",
        DatosCorteTurno: "Muestra los datos de movimentos de caja realizados en un turno",
        ReporteResumenTurno: "Permiso para obtener el reporte de resumen de turno",
        CrearTurnoDiferenteUsuario: "Si se deshabilita el usuaro sólo se podrá crear turnos a sí mismo",
        CrearTurnoDiferenteSucursal: "Si se deshabilita el usuario sólo podrá crear turnos a los usuarios de su misma sucursal",
        ConsultarTurnosSucursalDiferenteUsuario: "Si se deshabilita el usuario sólo podrá consultar turnos en su misma sucursal",

    },
    CargaDescargaRuta: {
        VerMenu: "Ver link de carga descarga",
        ConsultarCargasDescargas: "Consultar carga y descarga",
        ConsultarCargasSucursalDiferenteUsuario: "Permiso para consultar el listado de las cargas/descargas y para consultar una carga dado su ID",
        ImprimirReporteManifiesto: "Permiso para imprimir el reporte de manifiesto",
        ObtenerDestinosDeCargaEnSucursal: "Obtener el listado de los destinos de carga que se encuentran en un almacen",
        ObtenerDestinosDescargaEnCaja: "Obtener el listado de los destinos de descarga que se encuentran en una caja",
        CancelarCargaDescarga: "Cancela una carga o descarga",
        IniciarCargaDescarga: "Iniciar una carga/descarga",
        EscanearFolio: "True para poder escanear un folio para agregar un servicio a una carga/descarga",
        ObtenerGuiasEnCargaDescarga: "Habilitar la consulta de las guias que pertenecen a una carga/descarga",
        ObtenerServiciosPendientes: "Habilita ver el listado de los servicios pendientes de guías incompletas en una carga/descarga",
        ObtenerResumen: "Habilitar consultar los datos del resumen de una carga/descarga",
        QuitarGuia: "Permite quitar una guia incluida en una carga/descarga en proceso",
        QuitarServicioIncompleto: "Permite quitar un servicio de una guia incompleta incluida en una carga/descarga en proceso",
        DescargarGuiaSinEnrutamiento: "Permite Descargar una guía en un proceso de carga o descarga sin verficar que haya un enrutamiento valido para esta descarga",
        ReabrirCargaDescarga: "Permite reabrir un proceso de carga/descarga",
        TeclearFolioEnCargaDescarga: "True para poder teclear el folio en una carga / descarga, falso sólo para permitir escanear con el celular ",
        VerConsultaManifiestosCarga: "Ver la ruta de consulta para manifiestos de carga"
    },
    Cobranza: {
        VerMenu: "Ver link de cobranza",
        ConsultarContrarecibo: "Consultar contrarecibos",
        ConsultarViajes: "Consultar viajes",
        GenerarContrarecibosFacturasHoy: "Generar contrarecibo facturas hoy",
        ObtenerContrarecibosDeViaje: "Obtener contrarecibos de viaje",
        ObtenerSugerenciaContrarecibo: "Obtener sugerencia contrarecibo",
        VerFiltroSucursalEnContrarecibos: "Ver el filtro de sucursal en el listado de contrarecibos",
        ConsultarContrarecibosCualquierSucursal: "Permite consultar contrarecibos de cualquier sucursal",
        VerFiltroSucursalEnViajesRevision: "Ver el filtro de sucursal en el listado de viajes de revision",
        ConsultarViajesRevisionCualquierSucursal: "Permite consultar viajes de revisión de cualquier sucursal",
        CrearViaje: "Crear un viaje de cobranza"
    },
    VerCatalogos: "Ver el link de los catálogos",
    VerOperacion: "Ver el link del cotizador",
    RecoleccionDomicilio: {
        VerBoton: "Ver el botón de recolección a domicilio en el detalle de una guia",
        MarcarRecoleccion: "Permiso para marcar una guia como recolectada a domicilio"
    },
    CorteVenta: {
        VerMenu: "Ver link de corte venta ",
        AgregarCorteVenta: "Generar un nuevo corte de ventas",
        GenerarReporteComisiones: "Generar reporte de comisiones",
        ObtenerCorteVentas: "Obtener los cortes de ventas"
    },
    CorteDiario: {
        VerMenu: "Ver link de corte diario",
        ObtenerCorteDiario: "Obtener los registros de cortes diarios",
        GenerarCorteDiario: "Permite generar un corte diario",
        GenerarMatrizCortes: "Generar matriz de corte",
        VerCortesTodasSucursales: "Permite ver los cortes diarios de todas las sucursales, si no tiene este permiso el usuario solo podrá ver los cortes de su sucursal"
    },
    MovimientoCaja: {
        VerMenu: "Ver link de movimiento de cajas",
        ObtenerMovimientosCajas: "Obtener movimientos de cajas"
    },
    ViajeRuta: {
        VerMenu: "Ver link de viaje de ruta",
        ConsultarViajeRuta: "Consultar los viaje de ruta del sistema",
        CrearViaje: "Permite crear un viaje de ruta",
        CancelarViaje: "Permite cancelar un viaje de ruta",
        DarSalida: "Permite dar salida a un viaje de ruta",
        DarLlegada: "Permite dar llegada a un viaje de ruta",
        ObtenerSugerenciasSegmento: "Permite obtener suferencias de segmento para un viaje de ruta",
        DarSalidaSucursalDiferenteUsuario: "Si se deshabilita el usuario no le podrá dar salida a viajes con una sucursal origen diferente a la sucursal del usuario",
        DarLlegadaSucursalDiferenteUsuario: "Si se deshabilita el usuario no le podrá dar llegada a viajes con una sucursal destino diferente a la sucursal del usuario",
        ConsultarViajeSucursalDiferenteUsuario: "Si se deshabilita el usuario sólo vera viajes que su sucursal de origen o destino sean igual a la sucursal del usuario",
    },
    Contabilidad: {
        VerMenu: "Ver link de polizas contables",
        ConsultarPolizas: "Permite consultar polizas contables",
        GetPoliza: "Permite ver el detalle de una poliza",
        VerBotonReenviarPoliza: "Permite ver el botón para reenviar una poliza de contabilidad",
        ReenviarPoliza: "Permite reenviar una poliza"
    },
    MovimientoCamionRuta: {
        VerMenu: "Ver link de movimientos de camiones en ruta",
        AsignarSucursal: "Permite asignar sucursal a un camión",
        ConsultarStatusDeMovimientoCamion: "Consultar status de movimiento de camiones"
    },
    MovimientoCajaRuta: {
        VerMenu: "Ver link de movmientos de caja ruta",
        ConsultarStatusCaja: "Consulta movimientos de cajas de rutas",
        ConsultaCajasConectadas: "Consultar relación de las cajas de ruta con los camiones",
        AsignarCaja: "Permite asignar cajas a un camión",
        AsignarCajaSucursal: "Permite asignar caja a una sucursal",
        ConectarCaja: "Permite conectar una caja a un camión",
        DesconectarCaja: "Permite desconectar una caja d eun camión"
    },
    Guia: {
        VerMenu: "Ver link de guias",
        ConsultarGuias: "Permite consultar todas las guias",
        ObtenerGuia: "Permite ver los detalles de una guia",
        ObtenerContactosAutorizados: "Permite obtener contactos autorizados para manejar una guia",
        ReporteAcuse: "Permite obtener un reporte de acuse",
        ReporteGuia: "Permite obtener un reporte de guia",
        ConsultarExistenciaPorFolio: "Habilitar al usuario saber si existe una guia dado su folio. Este permiso no le otorga ninguna información al usuario mas que la existencia de la guia",
        AsignarASucursal: "Permiso para asignar forzadamende una guia a cualquier sucursal, sobreescribiendo el status actual de la guia",
        VerBotonAsignarASucursal: "Permiso para ver el botón de asignar guía a sucursal",
        VerFiltroClienteOrigenEnConsultaGuias: "Permite ver el filtro de cliente origen en la consulta de guías",
        ConsultarGuiasCualquierClienteOrigen: "Permite consultar guías de cualquier cliente de origen",
        CancelarGuia: "Permite cancelar una guía siempre y cuando cumpla los requisitos",
        VerBotonCancelarGuia: "Muestra el botón para cancelar una guía",
        CancelarGuiasClienteOrigenDiferenteClienteUsuario: "Si el permiso esta deshabilitado, el usuario sólo podrá cancelar guias en caso de que el cliente origen de la guía sea igual al cliente asignado al usuario actual",
        CancelarGuiasConManifiestoRAD: "Si se deshabilita, el usuario no podrá cancelar guias que formen parte de un manifiesto de RAD que no este cancelado",
        CancelarGuiaRecolectada: "Si se deshabilita, el usuario sólo podrá cancelar guías con status RecoleccionPendiente",
        MarcarGuiaNoFacturable: "Permite marcar una guía como no facturable",
        VerBotonMarcarGuiaNoFacturable: "Muestra el botón para marcar una guía no facturable"
    },
    Enrutamiento: {
        VerMenu: "Ver link de enrutamiento"
    },
    BitacoraRAD: {
        VerMenu: "Ver el link en el menu de operativa",
        CambiarStatus: "Permiso para cambiar el status de un elemento de la bitacora",
        VerTodasSucursales: "Si es falso sólo vera los de su propia sucursal",
    },
    Cotizar: {
        VerMenu: "Ver link de cotización",
        ObtenerCotizacion: "Obtener cotización de algún viaje",
        VerEncabezado: "Ver botón de cotizar en el encabezado"
    },
    PermisosQR: {
        VerMenu: "Ver link de QR",
        VerEncabezado: "Ver botón de QR en el navbar",
        VerLinkInicio: "Ver link de QR en la pantalla de inicio del sistema"
    },
    Rastreo: {
        VerMenu: "Ver el link",
        VerEncabezado: "Ver el link en el encabezado",
        RastrearGuias: "Permiso para rastrear cualquier guia dado su folio/numero de guía",
        ObtenerInformacionClienteRecibio: "Permiso para obtener información del cliente adicional al rastreo",
        VerBotonInformacionCliente: "Ver botón de mostrar información del cliente"
    },
    ManifiestoRAD: {
        Cancelar: "Permiso para cancelar manifiestos de RAD",
        CancelarTerminados: "Permiso para cancelar un manifiesto de RAD que ya fue terminado",
        Terminar: "Permiso para marcar como terminado un manifiesto",
        Agregar: "Permiso para agregar un nuevo manifiesto",
        AgregarCualquierCliente: "Si se deshabilita, el usuario sólo podra agregar manifiestos a su mismo cliente, se debe  de deshabilitar para los clientes de documentación en linea",
        Consultar: "Consultar los manifiestos",
        ConsultarCualquierCliente: "Si se deshabilita, el usuario sólo podra consultar los manifiestos que sean de su mismo cliente",
        VerMenu: "Ver el link de los manifiestos en el menu",
        ImprimirManifiesto: "Permiso para imprimir el reporte de manifiesto",
        ObtenerGuiasPosiblesManifiesto: "Permiso para obtener las guias posibles de un nuevo manifiesto",
        VerBotonCancelarManifiesto: "Permiso para ver el botón de cancelar un manifiesto rad",
        VerBotonTerminarManifiesto: "Permite ver el botón de terminar manifiesto en el listado de manifiestos",
        AgregarCualquierSucursal: "Si se deshabilita, el usuario sólo podra agregar manifiestos de su misma sucursal, se debe  de deshabilitar para los clientes de documentación en linea",
        ConsultarCualquierSucursal: "Si se deshabilita, el usuario sólo podra consultar los manifiestos que sean de su misma sucursal"
    },
    FacturacionOnline: {
        VerMenu: "Ver el link de facturación online",
        FacturarGuiasOnline: "Permiso para facturar guías desde la sección de facturación online",
        VerEncabezado: "Ver el link en el encabezado del sistema",
        TimbrarFacturaOnline: "Permite timbrar una factura desde el modulo de facturación online",
        EnviarCorreoFacturaOnline: "Permite envíar un email de facturación al cliente desde el modulo de facturación online"
    },
    CorteIngresosZE: {
        VerMenu: "Ver el link de CorteIngresosZE",
        ConsultarCorteIngresos: "Permite ver los CorteIngresosZE",
        GenerarCorteIngresos: "Permite agregar un nuevo CorteIngresosZE"
    },
    EntregaIngresosUsuarioZE: {
        ...InfoCatalogo,
        VerBotonGenerarReporte: "Muestra el botón para generar reportes de entrega de ingresos",
        VerBotonCancelarEntrega: "Muestra el botón para cancelar una entrega de ingresos",
        GenerarReporteEntregaIngresos: "Permite generar el reporte de una entrega de ingresos",
        CancelarEntregaIngresos: "Permite cancelar una entrega de ingresos"
    },
    CargaZE: {
        VerMenu: "Ver elemento en el menú",
        EscanearFolio: "Escanear folio al agregar guías en CargaZE",
        ObtenerResumen: "Obtener resumen de guías en CargaZE",
        ObtenerServiciosPendientes: "Obtener servicio pendientes en CargaZE",
        QuitarServicioIncompleto: "Quitar servicios incompletos en CargaZE",
        ObtenerGuias: "Obtener guias en CargaZE",
        QuitarGuia: "Quitar guia de CargaZE",
        Iniciar: "Permite iniciar elementos de CargaZE",
        Consultar: "Permite consultar elementos de CargaZE",
        Editar: "Permite modificar elementos de CargaZE",
        Eliminar: "Permite eliminar elementos de CargaZE",
        Cerrar: "Cierra una carga de zona extendida CargaZE",
        ImprimirManifiesto: "Permite imprimir el manifiesto de CargaZE",
        VerBotonImprimirManifiesto: "Muestra el botón para imprimir manifiesto de CargaZE",
        VerBotonEditarCarga: "Muestra el botón para modificar una carga ZE",
        VerBotonEliminarCarga: "Muestra el botón para eliminar una carga de ZE",
        VerMenuManifiestoCargaZE: "Muestra el menú de manifiesto de carga ZE",
        GenerarManifiestoCargaZE: "Permite generar un manifiesto de carga ZE"
    },
    DescargaZE: {
        Consultar: "Consultar descargas de zona extendida",
        EscanearFolio: "Escanear folio de descarga de zona extendida",
        ObtenerResumen: "Obtener resumen de descarga de zona extendida",
        Iniciar: "Iniciar descarga de zona extendida",
        ObtenerServiciosPendientes: "Obtener servicios pendietes de zona extendida",
        QuitarServicioIncompleto: "Quitar servicio incompleto de zona extendida",
        ObtenerGuias: "Obtener guías de zona extendida",
        QuitarGuia: "Quitar guía de una descarga de zona extendida",
        Eliminar: "Eliminar descarga de zona extendida",
        VerMenuDescargaZE: "Ver menú descarga de zona extendida",
        VerBotonEditarDescargaZE: "Ver boton editar descarga de zona extendida",
        VerBotonEliminarDescargaZE: "Ver boton eliminar descarga de zona extendida"
    },
    ResumenChoferZE: {
        VerMenuResumenChoferZE: "Ver el menú de resumen chofer de ZE",
        ConsultarResumenChoferZE: "Consultar Resumen chofer de ZE"
    },
    SaldosUsuarioZE: {
        VerMenuSaldosUsuariosZE: "Ver el menú de saldos de usuarios de ZE",
        ConsultarSaldosUsuarioZE: "Consultar saldos de usuario de ZE"
    },
    ConsultaVehiculoZE: {
        VerMenuConsultaVehiculoZE: "Ver el menú de consulta de vehículo de ZE",
        ConsultarVehiculoZE: "Consultar ínformación de vehículos de ZE",
        VerBotonImprimirManifiestoVehiculoZE: "Mostrar botón para imprimir manifiestos de vehículos de ZE",
        GenerarManifiestoVehiculoZE: "Genera un manifiesto de vehículo de ZE"
    },
    LiberacionesEntregaZE: {
        VerMenuLiberacionesEntregaZE: "Ver el menú de liberaciones de entrega de ZE",
        ConsultarLiberacionEntregaZ: "Consultar liberaciones de entrega de ZE",
        VerBotonLiberarEntrega: "Ver botón de liberar entrega",
        VerBotonGenerarReporteAcuses: "Ver botón generar reporte de acuses",
        LiberarEntregaZE: "Permite liberar una entrega",
        GenerarReporteAcuseInternoEntregaZE: "Permite generar un acuse interno"
    },
    PaquetesPP: {
        Agregar: "Agregar un nuevo paquete de PP",
        Consultar: "Consultar los paquetes de PP, ya sea uno o el listado",
        VerMenu: "Ver el link de paquetes de PP en el listado de operativa",
        ConsultarClientesDiferentes: "Si esta deshabilitado, el usuario sólo podrá consultar los paquetes de su cliente relacionado",
        ConsultarGuiasPP: "Si el usuario tiene permiso de consultar los folios de las guías de PP de todos los clientes, si es false sólo podrá ver de su mismo cliente",
        ConsultarGuiasPPTodosClientes: "Si el usuario tiene permiso de consultar los folios de las guías de PP de todos los clientes, si es false sólo podrá ver de su mismo cliente",
        ImprimirGuias: "Imprimir las guías de PP de un paquete",
        ConsultarCualquierSucursal: "True para que el usuario pueda consultar guíasPP de cualquier sucursal, en caso contrario solo podrá consultar guías de la sucursal en la que está asignado",
        MarcarPaquetesPagados: "True para que el usuario pueda marcar los paquetes pp como pagados",
        CancelarPaquetePP: "True para que el usuario pueda cancelar los paquetes pp",
    },
    PermisosLogistica:{
        VerFacturasLogisticaYPaqueteria: "True para que el usuario pueda ver las facturas de logistica junto con las de paqueteria"
    }
}


function initMap(map: any, value: any): any {
    return mapObject(map, (val, key) => {
        if (typeof (val) == "object")
            return initMap(val, value[key] || {});
        else
            return value[key];
    })
}

/**Se asegura que todos los valores del rol esten */
export function initRol(rol: Rol): Rol {
    return initMap(DeclaracionRoles, rol);
}
/**Rol por default donde todo esta en false */
export const RolDefault: Rol = initMap(DeclaracionRoles, {});


// WEBPACK FOOTER //
// ./app/models/rolmap.ts